export const openNewTab = (url: string, options?: { fileName?: string; target?: string }): void => {
  const link = document.createElement('a')
  link.href = url
  link.target = options?.target ?? '_blank'
  if (options?.fileName) {
    link.download = options.fileName
  }
  link.rel = 'noopener noreferrer'
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
